import { createAsyncThunk } from "@reduxjs/toolkit";
import { getItemOriginsApi, saveOriginManageApi, deleteItemOriginApi } from "../../apiservice/inventory";

export const fetchOriginsList = createAsyncThunk(
  "origins/fetchOriginsList",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getItemOriginsApi(null);
    
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const createOrUpdateOrigin = createAsyncThunk(
  "origins/createOrUpdateOrigin",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await saveOriginManageApi(payload);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const deleteOrigin = createAsyncThunk(
  "origins/deleteOrigin",
  async (origin_id, { rejectWithValue }) => {
    try {
      const res = await deleteItemOriginApi({ origin_id });
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
